import React, { useMemo, useCallback } from 'react';

interface ChartButtonsProps {
  symbols: string[];
  activeIndex: number | null;
  handleButtonClick: (index: number) => void;
  chartKey?: string;
}

const ChartButtons: React.FC<ChartButtonsProps> = ({ symbols, activeIndex, handleButtonClick }) => {
  return (
    <div className="buttonContainer">
      {symbols.map((symbol, index) => (
        <div
          key={symbol}
          className={`chartButton ${activeIndex === index ? 'chartButton__active' : ''}`}
          onClick={() => handleButtonClick(index)}
        >
          <span>{symbol}</span>
        </div>
      ))}
    </div>
  );
};

// Wrapping with React.memo
export default React.memo(ChartButtons);
